export const LOCALSTORAGE_KEYS = {
  singleTokenKey: 'singleToken',
  impersonateAccessTokenKey: 'impersonateAccessToken',
  impersonateRefreshTokenKey: 'impersonateRefreshToken',
  signUpFieldsKey: 'signUpFields',
  accessTokenKey: 'accessToken',
  refreshTokenKey: 'refreshToken',
};
